module.exports = __webpack_public_path__ + "img/ico_order_card.b3a45a8.png";